function removeProductBundle(button) {
    const bundlesFormElement = document.querySelector('bundles-form'); // Obtener la referencia del componente BundlesForm
    
    // Encontrar el contenedor del producto más cercano y eliminarlo
    const productToRemove = button.closest('.bundle-product-content');
    productToRemove.remove();

    // Actualizar el valor de qty en la URL
    let qty = parseInt(bundlesFormElement.getUrlParameter('qty')) - 1;

    // Validar si la cantidad es mayor que el mínimo permitido
    if (qty > bundlesFormElement.minQty) {
        // Buscar el último bundle-product-content
        const lastProduct = bundlesFormElement.querySelectorAll('.bundle-product-content')[qty - 1]; // Indices empiezan en 0
        const productIndex = `Clutch ${qty}`;

        // Actualizar el contenido del último producto para agregar el botón de eliminar
        const headingElement = lastProduct.querySelector('h2');
        // Crear un nuevo div
        const divElement = document.createElement('div');
        divElement.classList.add('heading');

        divElement.appendChild(headingElement);
        
        headingElement.innerHTML = `${productIndex}`;
        if (!lastProduct.querySelector('.remove')) {
            divElement.insertAdjacentHTML('beforeend', `
                <button class="remove" onclick="removeProductBundle(this)">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3536 5.64645C18.5488 5.84171 18.5488 6.15829 18.3536 6.35355L6.35355 18.3536C6.15829 18.5488 5.84171 18.5488 5.64645 18.3536C5.45118 18.1583 5.45118 17.8417 5.64645 17.6464L17.6464 5.64645C17.8417 5.45118 18.1583 5.45118 18.3536 5.64645Z" fill="#141414"/>
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.64645 5.64645C5.84171 5.45118 6.15829 5.45118 6.35355 5.64645L18.3536 17.6464C18.5488 17.8417 18.5488 18.1583 18.3536 18.3536C18.1583 18.5488 17.8417 18.5488 17.6464 18.3536L5.64645 6.35355C5.45118 6.15829 5.45118 5.84171 5.64645 5.64645Z" fill="#141414"/>
                        </svg>
                </button>
            `);
            lastProduct.prepend(divElement);
        }
    }

    bundlesFormElement.updateUrlParameter('qty', qty);
    // Actualizar el título del producto en la página
    bundlesFormElement.closest('product-info').querySelector('.product__title h1').innerHTML = `${qty} ${bundlesFormElement.original_title}`;

    //Actualizar el titulo del boton para agregar un nuevo producto
    bundlesFormElement.querySelector('#add-bundle-product .text').innerHTML = `Add Clutch ${qty + 1}`;
    // Volver a calcular el precio del bundle
    bundlesFormElement.fetchBundlePrice(qty);
}

class BundlesForm extends HTMLElement {
    constructor() {
        super();

        // Datos del objeto
        this.data = window.bundle_options;
        this.data_prices = window.fetch_price_url;
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.original_title = this.closest('product-info').querySelector('.product__title h1').innerHTML;

        // Definir el máximo de productos permitidos
        this.maxQty = 15;
        // Definir el minimo de productos permitidos
        this.minQty = 2;
        
    }

    // Este método se ejecuta cuando el elemento se conecta al DOM
    connectedCallback() {
        let qty = parseInt(this.getUrlParameter('qty')) || 2;

        if(!this.getUrlParameter('qty')){
            this.updateUrlParameter('qty', 2);
        }

        // Limitar qty a un máximo de 15
        if (qty > this.maxQty) {
            qty = this.maxQty;
            this.updateUrlParameter('qty', qty);  // Actualizar la URL si supera el máximo
        }else if(qty < this.minQty) {
            qty = this.minQty;
            this.updateUrlParameter('qty', qty);  // Actualizar la URL si supera el máximo
        }

        this.render(qty);
    }

    // Función para obtener el valor de un parámetro de la URL
    getUrlParameter(name) {
        const urlParams = new URLSearchParams(window.location.search);
        return urlParams.get(name);
    }

    // Función para actualizar el parámetro qty en la URL sin recargar la página
    updateUrlParameter(param, value) {
        const url = new URL(window.location.href);
        url.searchParams.set(param, value);
        window.history.replaceState(null, null, url);
    }

    // Método principal para renderizar el contenido del componente
    render(qty) {
        
        // Generar el contenido en función del parámetro qty
        for (let i = 1; i <= qty; i++) {
            let last = false;
            if(qty==i){ last = true;}
            this.addProductBundleToContent(i,last);
        }

        this.addButtonToAddNewProduct(qty);

        for (let i = 1; i <= qty; i++) {
        // Añadir las variantes del primer producto por defecto en cada linea  de producto
        this.updateVariantSelect(i, true);
        }

        this.querySelector('.add-to-cart-bundle').addEventListener('click', this.addToCartBundle.bind(this));

        //Modificando el titulo del producto
        this.closest('product-info').querySelector('.product__title h1').innerHTML = `${qty +' '+ this.original_title}`;
        
        //Modificar el precio del producto
        this.fetchBundlePrice(qty);
    }

    //Funcion para agregar un elemento de producto al contenido de los bundles
    addProductBundleToContent(i, last=false) {

        if(last){
            // Buscar el último bundle-product-content
            const lastProduct = this.querySelectorAll('.bundle-product-content')[i - 2]; // Indices empiezan en 0
            const productIndex = `Clutch ${i}`;

            // Actualizar el contenido del último producto para agregar el botón de eliminar
            const headingElement = lastProduct.querySelector('h2');
            
            // Crear un nuevo div
            const headingElementCloned = document.createElement('h2');

            headingElementCloned.innerHTML = headingElement.innerHTML;

            if (lastProduct.querySelector('.remove')) {
                headingElement.parentNode.remove();
                lastProduct.prepend(headingElementCloned);
            }
        }
        const productIndex = `Clutch ${i}`;
        const div = document.createElement('div');
        div.id = `bundle-product-${i}`;
        div.classList.add('bundle-product-content');
        div.innerHTML = `<h2>${productIndex}</h2>`;
        if(last && i > this.minQty){
            div.innerHTML = `<div class="heading"><h2>${productIndex}</h2> <button class="remove"  onclick="removeProductBundle(this)"><svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M18.3536 5.64645C18.5488 5.84171 18.5488 6.15829 18.3536 6.35355L6.35355 18.3536C6.15829 18.5488 5.84171 18.5488 5.64645 18.3536C5.45118 18.1583 5.45118 17.8417 5.64645 17.6464L17.6464 5.64645C17.8417 5.45118 18.1583 5.45118 18.3536 5.64645Z" fill="#141414"/>
                                <path fill-rule="evenodd" clip-rule="evenodd" d="M5.64645 5.64645C5.84171 5.45118 6.15829 5.45118 6.35355 5.64645L18.3536 17.6464C18.5488 17.8417 18.5488 18.1583 18.3536 18.3536C18.1583 18.5488 17.8417 18.5488 17.6464 18.3536L5.64645 6.35355C5.45118 6.15829 5.45118 5.84171 5.64645 5.64645Z" fill="#141414"/>
                                </svg></button><div>`;
        }
        
        // Crear el contenedor para la imagen y el select de productos
        const productContainer = document.createElement('div');
        productContainer.classList.add('product-container');
    
        // Crear la imagen
        const img = document.createElement('img');
        img.src = 'ruta_de_imagen'; // Reemplaza con la ruta de la imagen
        img.alt = `Imagen del producto ${i}`;
        
        // Crear el select de productos
        const productSelect = document.createElement('select');
        productSelect.id = `product-select-${i}`;
    
        // Añadir opciones de productos
        this.data.options.forEach((product, index) => {
            const option = document.createElement('option');
            option.value = product.product_id;
            option.text = product.product_title;
            if (index === 0) option.selected = true;
            productSelect.appendChild(option);
        });
    
        // Añadir la imagen y el select de productos al contenedor
        productContainer.appendChild(img);
        productContainer.appendChild(productSelect);
    
        // Crear el select de variantes
        const variantSelect = document.createElement('select');
        variantSelect.classList.add('product-bundle-variant-id');
        variantSelect.id = `variant-select-${i}`;
    
        // Crear el label para el select de variantes
        const label = document.createElement('label');
        label.setAttribute('for', `variant-select-${i}`);
        
        // Crear el span como hermano del select
        const span = document.createElement('span');
        span.classList.add('circle-color', 'color-black'); // Clase inicial (puedes ajustarla)
    
        // Añadir el select de variantes y el span al label
        label.appendChild(span);
        label.appendChild(variantSelect);
    
        // Añadir el evento onchange correctamente
        productSelect.addEventListener('change', () => {
            this.updateVariantSelect(i);
        });

        label.addEventListener('click', evt => {
            let select = evt.target;
            select.focus();
        })
    
        // Añadir evento al variantSelect para actualizar la clase del span
        variantSelect.addEventListener('change', (event) => {
            const selectedOption = variantSelect.options[variantSelect.selectedIndex].text.toLowerCase();
            span.className = `circle-color color-${selectedOption}`; // Actualizar la clase del span
            event.target.closest('.bundle-product-content').querySelector('.product-container img').setAttribute('src',variantSelect.options[variantSelect.selectedIndex].dataset.img_src);
        });
    
        // Crear el contenedor para envolver todo
        const div_wrap = document.createElement('div');
        div_wrap.classList.add('bundle-product-wrap');
    
        // Añadir el contenedor con la imagen y el select de productos
        div_wrap.appendChild(productContainer);
    
        // Añadir el label con el select de variantes
        div_wrap.appendChild(label);
    
        // Añadir todo al contenedor principal
        div.appendChild(div_wrap);
        
        this.querySelector('.bundles-container').appendChild(div);
    }    

    // Función para actualizar el select de variantes
    updateVariantSelect(index, initial = false) {
        const productSelect = this.querySelector(`#product-select-${index}`);
        const variantSelect = this.querySelector(`#variant-select-${index}`);
    
        // Guardar el texto de la opción seleccionada previamente
        const previousSelectedText = variantSelect.options[variantSelect.selectedIndex]?.text;
    
        // Limpiar las opciones anteriores del select de variantes
        variantSelect.innerHTML = '';
    
        // Encontrar el producto seleccionado
        const selectedProductId = productSelect.value;
        const selectedProduct = this.data.options.find(product => product.product_id === selectedProductId);
    
        // Crear las opciones de variantes
        selectedProduct.variants.forEach(variant => {
            const option = document.createElement('option');
            option.value = variant.id;
            option.text = variant.color;
            if(variant.available != "true"){
              option.disabled = "disabled";
            }
            console.log(variant)
            option.setAttribute('data-img_src', variant.image);
            variantSelect.appendChild(option);
        });
    
        // Seleccionar la opción previa basada en el texto
        let optionFound = false;
        for (let i = 0; i < variantSelect.options.length; i++) {
            if (variantSelect.options[i].text === previousSelectedText && !variantSelect.options[i].hasAttribute('disabled')) {
                variantSelect.selectedIndex = i;
                const selectedOption = variantSelect.options[i].text.toLowerCase();
                variantSelect.parentNode.querySelector('.circle-color').className = `circle-color color-${selectedOption}`;
                variantSelect.closest('.bundle-product-content').querySelector('.product-container img').setAttribute('src',variantSelect.options[i].dataset.img_src);
                optionFound = true;
                break;
            }
        }
    
        // Si no se encontró la opción anterior, seleccionar la primera por defecto
        if (!optionFound || initial) {
            variantSelect.selectedIndex = 0;
            const selectedOption = variantSelect.options[0].text.toLowerCase();
            variantSelect.parentNode.querySelector('.circle-color').className = `circle-color color-${selectedOption}`;
            variantSelect.closest('.bundle-product-content').querySelector('.product-container img').setAttribute('src',variantSelect.options[0].dataset.img_src);
        }
    }    

    //Funcion para poner el boton que permite agregar mas clutch
    addButtonToAddNewProduct(qty){
        const productIndex = `Add Clutch ${qty + 1}`;
        let button = document.createElement('button');
        button.id = `add-bundle-product`
        button.innerHTML = `<span class="text">${productIndex}</span> <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 7C12.2761 7 12.5 7.14924 12.5 7.33333V16.6667C12.5 16.8508 12.2761 17 12 17C11.7239 17 11.5 16.8508 11.5 16.6667V7.33333C11.5 7.14924 11.7239 7 12 7Z" fill="#141414"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7 12C7 11.7239 7.14924 11.5 7.33333 11.5H16.6667C16.8508 11.5 17 11.7239 17 12C17 12.2761 16.8508 12.5 16.6667 12.5H7.33333C7.14924 12.5 7 12.2761 7 12Z" fill="#141414"/>
            <path fill-rule="evenodd" clip-rule="evenodd" d="M12 2.5C6.75329 2.5 2.5 6.75329 2.5 12C2.5 17.2467 6.75329 21.5 12 21.5C17.2467 21.5 21.5 17.2467 21.5 12C21.5 6.75329 17.2467 2.5 12 2.5ZM1.5 12C1.5 6.20101 6.20101 1.5 12 1.5C17.799 1.5 22.5 6.20101 22.5 12C22.5 17.799 17.799 22.5 12 22.5C6.20101 22.5 1.5 17.799 1.5 12Z" fill="#141414"/>
            </svg>`;

        // Deshabilitar el botón si ya se alcanzó el máximo
        if (qty >= this.maxQty) {
            button.disabled = true;
            button.innerHTML = 'Maximum reached';
        } else {
            button.addEventListener('click', event => {
                let newQty = parseInt(this.getUrlParameter('qty')) + 1;

                if (newQty <= this.maxQty) {
                    this.addProductBundleToContent(newQty, true);
                    this.updateUrlParameter('qty', newQty);
                    this.updateVariantSelect(newQty, true);
                    event.currentTarget.querySelector('.text').innerHTML = `Add Clutch ${newQty + 1}`;
                    //Modificando el titulo del producto
                    this.closest('product-info').querySelector('.product__title h1').innerHTML = `${newQty +' '+ this.original_title}`;

                    
                }

                if (newQty === this.maxQty) {
                    button.disabled = true;
                    button.innerHTML = 'Maximum reached';
                }
                this.fetchBundlePrice(newQty);
            });
        }

        let buttonATC = this.querySelector('.add-to-cart-bundle');
        this.insertBefore(button, buttonATC);
    }

    //Funcion para agregar al carro el bundle
    addToCartBundle(){
        let config = fetchConfig('javascript');
        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData();
        formData.append('form_type', "cart");

        // Reemplazar la lógica de items por el nuevo formato
        this.querySelectorAll('.product-bundle-variant-id').forEach(element => {
            const id = parseInt(element.value); // Convertir el valor a número

            // Buscar si ya existe un campo updates para este id
            if (formData.has(`updates[${id}]`)) {
                // Si existe, incrementar la cantidad
                let currentQuantity = parseInt(formData.get(`updates[${id}]`));
                formData.set(`updates[${id}]`, currentQuantity + 1);
            } else {
                // Si no existe, agregar el nuevo campo con cantidad 1
                formData.append(`updates[${id}]`, 1);
            }
        });

        if (this.cart) {
            formData.append(
                'sections',
                this.cart.getSectionsToRender().map((section) => section.id)
            );
            formData.append('sections_url', window.location.pathname);
        }

        config.body = formData;

        fetch(window.Shopify.routes.root + 'cart/update.js', config)
            .then((response) => response.json())
            .then((response) => {
                if (!this.cart) {
                    window.location = window.routes.cart_url;
                    return;
                }
                this.cart.renderContents(response);
            })
            .catch((e) => {
                console.error(e);
            });
    }

    // Método para obtener el parámetro 'qty' y realizar el fetch para actualizar el precio
    fetchBundlePrice(qty) {
        const qtyBundle = `${qty} Clutch Bundle`; // Construir la cadena
        let fetchUrl = '';
        console.log(qtyBundle)
        // Buscar si existe un elemento con qty_bundle igual a la cadena
        const foundBundle = this.data_prices.find(bundle => bundle.qty_bundle === qtyBundle);
        if (foundBundle) {
            fetchUrl = foundBundle.fetch_url; // Guardar el fetch_url si se encuentra
        }

        // Si encontramos una URL válida, hacer el fetch
        if (fetchUrl) {
            fetch(fetchUrl)
                .then(response => response.text()) // Obtener el HTML como texto
                .then(html => {
                    // Crear una instancia de DOMParser
                    const parser = new DOMParser();

                    // Parsear el texto HTML a un documento HTML
                    const doc = parser.parseFromString(html, 'text/html');

                    // Buscar el elemento con las clases ".no-js-hidden.product__price" en el documento parseado
                    const newPriceElement = doc.querySelector('.no-js-hidden.product__price');
                    
                    if (newPriceElement) {
                        // Reemplazar el elemento en nuestro DOM
                        const currentPriceElement = this.closest('product-info').querySelector('.no-js-hidden.product__price');
                        if (currentPriceElement) {
                            currentPriceElement.replaceWith(newPriceElement);
                            let promo = "Save 20% Off";
                            if(qty == 3) {
                                promo = "Save 30% Off";
                            }else if (qty >= 4){
                                promo = "Save 40% Off";
                            }
                            newPriceElement.querySelector('.price__container').dataset.promo = promo;
                        }
                    }
                })
                .catch(error => console.error('Error al obtener el precio del bundle:', error));
        }
    }
}
// Definir el nuevo elemento personalizado
customElements.define('bundles-form', BundlesForm);

